import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

import { asyncPayloadCreator } from 'utils';

import { Verify2FAProps } from 'models/api';

export const verify2FA = createAsyncThunk(
	'verify2FA/verify2FA',
	(credentials: Verify2FAProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.verify2FA),
);
